import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "#59AD3B",
      "fill-opacity": ".15",
      rx: "8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59AD3B",
      d: "M8.376 9.405H7.287c.003-.302.03-.556.078-.761.05-.209.13-.398.244-.567.118-.17.272-.348.464-.537.15-.143.285-.278.406-.405.12-.13.216-.267.288-.41a1.13 1.13 0 0 0 .107-.503c0-.205-.034-.38-.103-.523a.72.72 0 0 0-.302-.327.968.968 0 0 0-.489-.112c-.162 0-.315.032-.459.097a.777.777 0 0 0-.346.293c-.088.13-.135.303-.142.518H5.856c.007-.41.105-.755.293-1.035.19-.28.443-.49.762-.63.32-.14.676-.21 1.07-.21.436 0 .808.075 1.118.225.309.146.545.36.708.644.166.28.249.619.249 1.016 0 .286-.057.547-.171.781a2.842 2.842 0 0 1-.445.65c-.182.198-.379.397-.59.595a1.288 1.288 0 0 0-.371.542c-.066.192-.1.412-.103.66ZM7.189 10.93c0-.176.06-.324.181-.445.12-.123.285-.185.493-.185.209 0 .373.062.493.185.12.12.181.269.181.445a.62.62 0 0 1-.18.449c-.121.12-.285.18-.494.18-.208 0-.372-.06-.493-.18a.62.62 0 0 1-.18-.45Z"
    }, null, -1)
  ]))]))
}
export default { render: render }